// extracted by mini-css-extract-plugin
export default {"round":"CheckBoxV3_round__7OYXC","container":"CheckBoxV3_container__30Z0s"};